import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import useOverviewContext from "../../store/use-overview-context";

const FiltersControlField = ({ id }) => {
  const { config, isFilterSet, removeFilter, setFilter, loading } =
    useOverviewContext();

  const fieldConfig = config.fields.find((field) => field.id === id);
  const disabled = !!loading;

  const handleClick = (event, value, isSelected) => {
    event.preventDefault();
    if (disabled) return;
    if (isSelected) {
      removeFilter(id, value);
    } else {
      setFilter(id, [value]);
    }
  };

  return (
    <>
      {fieldConfig.values &&
        fieldConfig.values.map((valueConfig, ix) => {
          const isFilterSelected = isFilterSet(id, valueConfig.value);

          const buttonClasses = classNames({
            "filters-control": true,
            "filters-control-field": true,
            "filters-control-field--selected": isFilterSelected,
          });

          const iconClasses = classNames({
            icon: true,
            "icon-headphones": valueConfig.value === "audio",
            "icon-playvideo": valueConfig.value === "video",
            "icon-unknown":
              valueConfig.value !== "audio" && valueConfig.value !== "video",
          });

          return (
            <button
              className={buttonClasses}
              disabled={disabled}
              title={valueConfig.label}
              onClick={(event) =>
                handleClick(event, valueConfig.value, isFilterSelected)
              }
              key={ix}
            >
              <span className={iconClasses} />
              <span className="filters-control-field-label">
                {valueConfig.label}
              </span>
            </button>
          );
        })}
    </>
  );
};

FiltersControlField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FiltersControlField;
